module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('span', {
    attrs: {
      "id": "id-93107411740218013"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ph"
  }, [_vm._v("THE HARDY BOYS")]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("THE HOUSE\nON THE CLIFF")]), _vm._v(" "), _c('div', {
    staticClass: "ph"
  }, [_vm._v("By FRANKLIN W. DIXON")])]), _vm._v(" "), _c('div', {
    staticClass: "figcenter",
    attrs: {
      "id": "frontis"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "",
      "id": "id-5733789868116482082",
      "src": "OEBPS/Images/557129876733097726_frontis.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption0"
    }
  }, [_vm._v("“WE’VE FOUND THE PASSAGE!” (Chapter XVII)")])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7f298d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section00.vue
// module id = 57
// module chunks = 0